import React from 'react';

import AppointmentFormContainer from './../containers/AppointmentFormContainer';

export class AppointmentPage extends React.Component {
    render() {
        return (
            <div className="gcm-m-appointment">
                <h3 className="gcm-m-appointment-title">Запись на медосмотр</h3>
                <AppointmentFormContainer />
                <div style={{ marginTop: '30px' }}>
                    <p>
                        Если Вы не нашли удобного времени, позвоните нам:
                        <a href="tel:73833280103">+7 (383) 328-01-03</a>,
                        <a href="tel:73832090301">+7 (383) 209-03-01</a>
                    </p>
                    <p>Запись на детские мед. осмотры перед школой и садиком только по телефону</p>
                </div>
            </div>
        );
    }
}

export default AppointmentPage;



// WEBPACK FOOTER //
// frontend/src/modules/mobile/components/AppointmentPage.jsx